module.exports = __webpack_public_path__ + "img/x.3078cbe0.png";